<nav
  class="breadcrumb has-arrow-separator is-small has-text-grey-dark"
  aria-label="breadcrumbs"
>
  <ul itemscope itemtype="https://schema.org/BreadcrumbList" class="pl-0 my-0">
    <!-- Home link -->
    <li
      itemprop="itemListElement"
      itemscope
      itemtype="https://schema.org/ListItem"
    >
      <a itemprop="item" routerLink="/">
        <span class="icon is-small">
          <i class="fas fa-home" aria-hidden="true"></i>
        </span>
        <span>Home</span>
      </a>
    </li>

    <li
      itemprop="itemListElement"
      itemscope
      itemtype="https://schema.org/ListItem"
      *ngFor="
        let breadcrumbLink of breadcrumbLinks;
        let i = index;
        let last = last
      "
      [ngClass]="{ 'is-active': last || !breadcrumbLink.path }"
    >
      <a
        itemprop="item"
        [routerLink]="'/' + breadcrumbLink.path"
        [queryParams]="breadcrumbLink.queryParams"
        *ngIf="!last && breadcrumbLink.path"
      >
        {{ breadcrumbLink.label }}
      </a>

      <a itemprop="item" *ngIf="!last && !breadcrumbLink.path">
        {{ breadcrumbLink.label }}
      </a>

      <!-- Last item (current) -->
      <a itemprop="item" aria-current="page" *ngIf="last" class="is-active">
        {{ breadcrumbLink.label }}
      </a>
      <meta itemprop="position" [content]="i" />
    </li>
  </ul>
</nav>
